import { ReactComponent as MapPin } from "assets/patterns/gps-location.svg";
import { ReactComponent as Heart } from "assets/patterns/heart.svg";
import { NavLink } from "react-router-dom";
import { ICONS_MAP } from "assets/icons/iconsMap";

export default function HotelCard({ hotel, index }) {
  return (
    <NavLink
      to={`/hoteles/${hotel.Destino}/${hotel.Hotel}`}
      className="hotel-card"
      style={{ animationDelay: `${index * 120}ms` }}
    >
      <div className="hotel-card-inner">
        {/* Imagen */}
        <div className="hotel-image">
          <img src={hotel.slider?.[0]?.img} alt={hotel.Hotel} />
          <button className="start">
            <Heart />
          </button>
          <span className="hotel-category">{hotel.categoria}</span>
          <div className="hotel-location">
            <MapPin />
            <span>{hotel.Destino}</span>
          </div>
          <div className="hotel-location nights">
            <span>{hotel.noches ? "Consume tus noches" : "Convenio"}</span>
          </div>
        </div>

        {/* Contenido */}
        <div className="hotel-content">
          <section className="hotel-content-header">
            <h3 className="hotel-name">{hotel.Hotel}</h3>
            <div className="hotel-services">
              {hotel.iconos_servicios.slice(0, 3)?.map((servicio, idx) => {
                const iconName = servicio.icon.split("/").pop();
                const Icon = ICONS_MAP[iconName];

                return (
                  <div key={idx} className="service-icon-wrapper">
                    {Icon && <Icon className="service-icon" />}
                  </div>
                );
              })}
            </div>
          </section>

          <p className="hotel-description">
            {hotel.descripcion.slice(0, 120)}...
          </p>

          <button className="hotel-button">Ver hotel</button>
        </div>
      </div>
    </NavLink>
  );
}
